import { ITEM_TYPES } from '../types/ItemTypes';
import { PATTERNS } from './patterns';
export function getPatternBlob(itemType) {
  return PATTERNS[itemType] || PATTERNS[ITEM_TYPES.DEFAULT];
}